import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

export const BASE_URL = `${publicRuntimeConfig.apiUrl}/api/v1`;

export const HOST_BASE_URL = `${publicRuntimeConfig.hostUrl}/api`;

export const API_PATHS = {
  CUSTOMER_INFORMATION: '/customer/customer-information',
  CUSTOMER_POLICY_INITIAL_INFO: '/customer/fetchCustomerPolicyOtherData',
  CUSTOMER_AFFINITY_INFO: '/customer/fetchCustomerAffinities',
  USERS: '/customer/users',
  POLICY_LIST: '/customer/policies',
  POLICY_SUMMARY: '/customer/policySummary',
  PORTFOLIO_LIST: '/customer/sales-portfolio',
  GROUPED_PORTFOLIO_LIST: '/customer/grouped-sales-portfolio',
  PORTFOLIO_ALL_QUOTE_LINES: '/customer/allQuoteLines',
  PORTFOLIO_DELETE_QUOTE_LINE: '/customer/delete-quote-line-by-uuid',
  PORTFOLIO_DELETE_QUOTE: '/customer/delete-quote',
  PORTFOLIO_STATUS_COUNTER: '/customer/sales-portfolio/status-counter',
  POLICIES_STATUS_COUNTER: '/customer/policies/status-counter',
  POLICY_AGENT: '/customer/policy-agent',
  RESET_PASSWORD: '/customer/auth/update-password',
  VALIDATE_TOKEN: '/customer/auth/validate-token',
  CLAIMS: '/customer/claims',
  CLAIMS_DASHBOARD: '/customer/claims-dashboard',
  CLAIMS_CREATE_NOTE: '/claim/create-case-item',
  CLAIMS_GET_NOTE: '/claim/get-case-items',
  BILLING: '/customer/invoices',
  POLICY_BILLING: '/customer/policy-invoices',
  BILLING_ARCHIVES: '/customer/billing/archives',
  DOCUMENT_DOWNLAOD: '/download',
  UPLOAD_CLAIM_DOCUMENTS: '/upload-claim-documents',
  UPLOAD_CLAIM_CASEITEM: '/upload-claim-caseitem',
  UPLOAD_POLICY_DOCUMENTS: '/upload-policy-documents',
  PARTY_DOCUMENTS: '/customer/party-documents',
  POLICY_DOCUMENTS: '/customer/policy-documents',
  POLICYLINE_DOCUMENTS: '/customer/policy-line-documents',
  ATTACHMENTS: '/customer/attachments',
  DOWNLOAD_DOCUMENTS: '/customer/documentDownload',
  POLICY_DOCUMENTS_FILTERS: '/customer/policy-documents-filters',
  PARTY_DOCUMENTS_FILTERS: '/customer/party-documents-filters',
  MERGE_PDF: '/merge-pdf',
  RED_FLAG_STATUS: '/customer/red-flag-status',
  CUSTOMER_CLAIM_STATUS: '/customer/claim-status',
  TRAVEL_CARD: '/tia-customer-connect-get-travel-card-details',
  CREATE_PARTY: '/tia-create-partywithssn',
  UPDATE_CUSTOMER_SEGMENT: '/customer/updateCustomerSegment',

  FORGOT_PASSWORD: '/customer/auth/password',
  SALES_POLICY: '/customer/sales-policies',
  LOGIN: '/signin',
  CMS: '/cms',
  COMPANY_LIST: '/customer/company-list',
  PRODUCT_DETAILS: '/get-product-details',
};

// TIA base URL, workaround for download document API
export const CASE_BASE_URL = `${publicRuntimeConfig.rest2ApiUrl}case/api/v1` + '/attachments';

export const QUERY_CLIENT_CONFIG = {
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: 0,
      cacheTime: 1000 * 60 * 5,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      refetchInterval: 1000 * 60 * 5,
      refetchIntervalInBackground: false,
      suspense: false,
      keepPreviousData: false,
    },
    mutations: {
      retry: false,
    },
  },
};
